export const SET_SWITCH_TAB = "SET_SWITCH_TAB";

export const switchTab = (data) => (dispatch) => {
  dispatch({
    type: SET_SWITCH_TAB,
    payload: data,
  });
};